import { Injectable } from '@angular/core';
import { Store } from '../../../services/store';
import { Observable, tap } from 'rxjs';
import { ShipmentsProvider } from './shipments.provider';
import { toVoid } from '../../../utils/void';
import { ShipmentRowVm } from './models/shipment-row.view-model';

export interface ShipmentsState {
  loading: boolean;
  shipments: ShipmentRowVm[] | undefined;
}

const INITIAL_STATE: ShipmentsState = {
  loading: false,
  shipments: undefined
};

@Injectable({ providedIn: 'root' })
export class ShipmentsStore extends Store<ShipmentsState> {
  constructor(private provider: ShipmentsProvider) {
    super(INITIAL_STATE);
  }

  init(): Observable<void> {
    this.update(state => ({ ...state, loading: true }));

    return this.provider.getShipments()
      .pipe(
        tap(shipments => {
          this.update(state => ({
            ...state,
            loading: false,
            shipments: shipments.map(ShipmentRowVm.mapModelToViewModel)
          }));
        }),
        toVoid()
      );
  }
}
